import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { createId } from '@core/util/file';
import { ICON } from '@core/util/icon';
import {
	GetParcelUnitTitleDetailsFromPin,
	getLatestInstrumentNumber,
} from '@core/util/legalDescription';
import { ParcelUnit, UnitType } from '@models/matter';
import { SavedPin } from '@models/teranet';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterTitlesState } from '@state/matter/titles/titles.state';
import { SalePinState } from '@state/sale_pins';
import { cloneDeep } from 'lodash';

@Component({
	selector: 'app-parcels-sync-form',
	templateUrl: './parcels-sync-form.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ParcelsSyncFormComponent implements OnInit {
	@SelectSnapshot(SalePinState.getParents) parentPins: SavedPin[];
	@SelectSnapshot(MatterTitlesState.getAll) parcels: ParcelUnit[];

	@Input() set titleSearchPin(pin: SavedPin) {
		this.originalPin = pin;
		this.parcel = GetParcelUnitTitleDetailsFromPin(pin);
		this.latestInstrument = getLatestInstrumentNumber(pin);
	}

	@Output() onParcelUpdate = new EventEmitter<ParcelUnit>();

	public originalPin: SavedPin;
	public matchingParcel: ParcelUnit;

	public parcel: ParcelUnit;
	public latestInstrument: string;

	@Input() set showComparison(comparison) {
		this._showComparison = !comparison;

		this.toggleComparison();
	}

	public _showComparison: boolean = false;
	public ICON = ICON;
	public unitTypes = Object.values(UnitType);

	constructor() {}

	ngOnInit(): void {
		this.matchingParcel = this.parcels.find(
			(parcel) => parcel.pinNumber === this.originalPin.pin,
		);

		if (this.matchingParcel) {
			this.parcel = cloneDeep(this.matchingParcel);
		}
	}

	toggleComparison() {
		this._showComparison = !this._showComparison;

		this.updateParcel();
	}

	updateParcel() {
		this.onParcelUpdate.emit(
			this._showComparison
				? { ...this.parcel, id: this.matchingParcel?.id ?? createId() }
				: null,
		);
	}
}
